import { useEffect, useState } from "react";

export default function useForceSystemTheme() {    
    const [forceSystemTheme, setForceSystemTheme] = useState(
        () => {
            const stored = localStorage.getItem("forceSystemTheme");
            return stored === "true"; 
        }
    );

    useEffect(() => {
        localStorage.setItem("forceSystemTheme", String(forceSystemTheme));
    }, [forceSystemTheme]);

    return {
        forceSystemTheme,
        setForceSystemTheme
    }
}
